import React from "react";
import WhereItAllBegan from "./components/WhereItAllBegan";
import WhyWeExist from "./components/WhyWeExist";
import PeopleBehindMission from "./components/PeopleBehindMission";
import StepIntoMissionField from "./components/StepIntoMissionField";
import WantToLearnMore from "./components/WantToLearnMore";

function AboutUs() {
  return (
    <div className="min-h-screen bg-white">
      <WhereItAllBegan />
      <WhyWeExist />
      <PeopleBehindMission />
      <StepIntoMissionField />
      <WantToLearnMore />
    </div>
  );
}

export default AboutUs;
